import { eventBus, EVENTS } from "./EventBus";

export class EditPermissionManager {
  constructor() {
    this.globalEditEnabled = true;

    this.customCheckFunction = null;
  }

  canEdit(item) {
    if (!this.globalEditEnabled) {
      console.log("bbbbb");

      return false;
    }

    if (item && item.editable === false) {
      return false;
    }

    if (item && item.locked === true) {
      return false;
    }

    if (item && item.status) {
      const nonEditableStatuses = [
        "confirmed",
        "locked",
        "completed",
        "archived",
        "finalized",
      ];
      if (nonEditableStatuses.includes(item.status.toLowerCase())) {
        return false;
      }
    }

    if (
      this.customCheckFunction &&
      typeof this.customCheckFunction === "function"
    ) {
      const result = this.customCheckFunction(item);
      if (result === false) {
        return false;
      }
    }

    return true;
  }

  setGlobalEditEnabled(enabled) {
    this.globalEditEnabled = enabled;
    eventBus.emit(EVENTS.EDIT_PERMISSION_CHANGED, { enabled });
  }

  isGlobalEditEnabled() {
    return this.globalEditEnabled;
  }

  setCustomCheck(fn) {
    if (typeof fn === "function") {
      this.customCheckFunction = fn;
    }
  }

  clearCustomCheck() {
    this.customCheckFunction = null;
  }

  getDisabledReason(item) {
    if (!this.globalEditEnabled) {
      return "Editing is disabled";
    }

    if (item && item.editable === false) {
      return "This item is not editable";
    }

    if (item && item.locked === true) {
      return "This item is locked";
    }

    if (item && item.status) {
      const nonEditableStatuses = [
        "confirmed",
        "locked",
        "completed",
        "archived",
        "finalized",
      ];
      if (nonEditableStatuses.includes(item.status.toLowerCase())) {
        return `Cannot edit items with status: ${item.status}`;
      }
    }

    if (this.customCheckFunction) {
      const result = this.customCheckFunction(item);
      if (result === false) {
        return "Custom validation failed";
      }
    }

    return null;
  }
}

export default EditPermissionManager;
